import * as DecoTypesDeclaration from '../Product/Product.DecoTypeDeclaration';
import * as ALCPricing from '../Product/Product.ALCPricing';
import * as ProductDecoTypes from '../Product/Product.DecoTypes';

declare global {
  var ALCPricing: any;
}

// Document Ready
$(function() {
  console.log("Product PDP Init - Started");
  console.log('Getting global configuration options');
  ProductDecoTypes.getGlobalProductOptionsConfiguration();

  if(Merchology.ProductDetails.isALCPricingProduct) {
    ALCPricing.showSelectedDecorationFees();
  }

  console.log("Product PDP Init - Done");

  window.ALCPricing = {};
  window.ALCPricing.addProductOptionsLineitemsToCart =  ALCPricing.addProductOptionsLineitemsToCart;
  window.ALCPricing.getFeeVariants = ALCPricing.getFeeVariants;

});
